import {
  //
  ADD_HOME_GROUP_ADMIN,
  ADD_HOME_GROUP_ADMIN_FAILURE,
  ADD_HOME_GROUP_ADMIN_SUCCESS,
  //
  DELETE_HOME_GROUP_ADMIN,
  DELETE_HOME_GROUP_ADMIN_FAILURE,
  DELETE_HOME_GROUP_ADMIN_SUCCESS,
  //
  EDIT_HOME_GROUP_ADMIN,
  EDIT_HOME_GROUP_ADMIN_FAILURE,
  EDIT_HOME_GROUP_ADMIN_SUCCESS,
  //
  FETCH_HOME_GROUP_ADMINS,
  FETCH_HOME_GROUP_ADMINS_FAILURE,
  FETCH_HOME_GROUP_ADMINS_SUCCESS,
  //
  GET_VIEW_DATA,
  GET_VIEW_DATA_FAILURE,
  GET_VIEW_DATA_SUCCESS,
  //
  GET_CHECK_MASTER_ADMIN,
  GET_CHECK_MASTER_ADMIN_FAILURE,
  GET_CHECK_MASTER_ADMIN_SUCCESS,
  //
  OPEN_ADMIN_ADD_MODAL,
  CLOSE_ADMIN_ADD_MODAL,
  //
  OPEN_ADMIN_EDIT_MODAL,
  CLOSE_ADMIN_EDIT_MODAL,
  SET_ADMIN_SUCCESS,
  SET_ADMIN_FAILURE,
  //
  TOGGLE_INVITE_MODAL,
  //
  INVITE_ADMIN,
  INVITE_ADMIN_SUCCESS,
  INVITE_ADMIN_FAILURE,
} from "./constants";

// List
export const fetchHomeGroupAdmins = (payload) => ({
  type: FETCH_HOME_GROUP_ADMINS,
  payload,
});
export const fetchHomeGroupAdminsSuccess = (payload) => ({
  type: FETCH_HOME_GROUP_ADMINS_SUCCESS,
  payload,
});
export const fetchHomeGroupAdminsFailure = (payload) => ({
  type: FETCH_HOME_GROUP_ADMINS_FAILURE,
  payload,
});
// View
export const getViewData = (payload) => ({
  type: GET_VIEW_DATA,
  payload,
});
export const getViewDataSuccess = (payload) => ({
  type: GET_VIEW_DATA_SUCCESS,
  payload,
});
export const getViewDataFailure = (payload) => ({
  type: GET_VIEW_DATA_FAILURE,
  payload,
});
// Check Master Admin
export const getCheckMasterAdmin = (payload) => ({
  type: GET_CHECK_MASTER_ADMIN,
  payload,
});
export const getCheckMasterAdminSuccess = (payload) => ({
  type: GET_CHECK_MASTER_ADMIN_SUCCESS,
  payload,
});
export const getCheckMasterAdminFailure = (payload) => ({
  type: GET_CHECK_MASTER_ADMIN_FAILURE,
  payload,
});
// ADD
export const addHomeGroupAdmin = (payload) => ({
  type: ADD_HOME_GROUP_ADMIN,
  payload,
});
export const addHomeGroupAdminSuccess = (payload) => ({
  type: ADD_HOME_GROUP_ADMIN_SUCCESS,
  payload,
});
export const addHomeGroupAdminFailure = (payload) => ({
  type: ADD_HOME_GROUP_ADMIN_FAILURE,
  payload,
});
// EDIT
export const editHomeGroupAdmin = (payload) => ({
  type: EDIT_HOME_GROUP_ADMIN,
  payload,
});
export const editHomeGroupAdminSuccess = (payload) => ({
  type: EDIT_HOME_GROUP_ADMIN_SUCCESS,
  payload,
});
export const editHomeGroupAdminFailure = (payload) => ({
  type: EDIT_HOME_GROUP_ADMIN_FAILURE,
  payload,
});
// DELETE
export const deleteHomeGroupAdmin = (payload, onDeleteSuccess) => ({
  type: DELETE_HOME_GROUP_ADMIN,
  payload,
  onDeleteSuccess,
});
export const deleteHomeGroupAdminSuccess = (payload) => ({
  type: DELETE_HOME_GROUP_ADMIN_SUCCESS,
  payload,
});
export const deleteHomeGroupAdminFailure = (payload) => ({
  type: DELETE_HOME_GROUP_ADMIN_FAILURE,
  payload,
});
//
export const openAdminAddModal = (payload) => ({
  type: OPEN_ADMIN_ADD_MODAL,
  payload,
});
export const closeAdminAddModal = (payload) => ({
  type: CLOSE_ADMIN_ADD_MODAL,
  payload,
});
//
export const openAdminEditModal = (payload) => ({
  type: OPEN_ADMIN_EDIT_MODAL,
  payload,
});
export const closeAdminEditModal = (payload) => ({
  type: CLOSE_ADMIN_EDIT_MODAL,
  payload,
});
export const setAdminSuccess = (payload) => ({
  type: SET_ADMIN_SUCCESS,
  payload,
});
export const setAdminFailure = (payload) => ({
  type: SET_ADMIN_FAILURE,
  payload,
});
//
export const toggleInviteModal = (payload) => ({
  type: TOGGLE_INVITE_MODAL,
  payload,
});
//
export const inviteAdmin = (payload, onInvSuccess) => ({
  type: INVITE_ADMIN,
  payload,
  onInvSuccess,
});
export const inviteAdminSuccess = (payload) => ({
  type: INVITE_ADMIN_SUCCESS,
  payload,
});
export const inviteAdminFailure = (payload) => ({
  type: INVITE_ADMIN_FAILURE,
  payload,
});
